import {NgModule} from '@angular/core';
import {CoreModule} from "@ispm/core/core.module";
import * as angular from 'angular';
import {ExternalActionComponent} from "./simple-auth/external-action.component"
import {ExternalFileDownloadService} from "./services/external-file-download.service";
import { ExternalCompleteWorkflow } from './services/external-completeworkflow.service';
import {RouterModule} from "@angular/router";


@NgModule({
  imports: [
    CoreModule,
    RouterModule.forRoot([])
  ],
  declarations: [ExternalActionComponent],
  exports: [ExternalActionComponent],
  providers: [ExternalFileDownloadService, ExternalCompleteWorkflow]
})
export class ExternalAction {
};



